module.exports = __webpack_public_path__ + "5e9b288383aabd4f0cdcab474007bbbb.svg";